export const fetchWidgetPosts = ({
  categoryId,
  paginationParams,
  fetchCategoryPosts,
  fetchFeedPosts,
  featuredOnly,
  excludeContent,
}) =>
  categoryId
    ? fetchCategoryPosts({ categoryId, featuredOnly, excludeContent, ...paginationParams })
    : fetchFeedPosts({ featuredOnly, excludeContent, ...paginationParams });
